import { createContext, useContext } from "react";

const SidebarContext = createContext({
  sidebarOpen: false,
  openSidebar: () => {},
});

export const SidebarProvider = SidebarContext.Provider;

export const useSidebar = () => useContext(SidebarContext);
